/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from '@mui/icons-material/Close';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveCajaAjuste } from "../../../project/services/CajaService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  descripcion: "",
  idTipoAjuste: "",
  importe: 0,
  motivoAnulacion: "",
};

const nameItemText = "Ajuste de Caja";
const itemGender = "M";
//
// ########################################################################### 
//
const CajaAjusteDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
  tiposAjuste,
  idCaja
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update" || actionCrud === "delete") {
      if (itemCrudLocal.idTipoAjuste === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo de Ajuste",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción",
        });
        setShowMessage(true);
        return;
      }
      if (isNaN(itemCrudLocal.importe) || itemCrudLocal.importe === 0) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un importe válido",
        });
        setShowMessage(true);
        return;
      }
      if (actionCrud === "delete" && itemCrudLocal.motivoAnulacion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el motivo de anulación",
        });
        setShowMessage(true);
        return;
      }

    }
    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {
    let _itemCrud = {
      idCaja: idCaja,
      idTipoAjuste: itemCrudLocal.idTipoAjuste,
      descripcion: itemCrudLocal.descripcion,
      importe: +itemCrudLocal.importe,
      motivoAnulacion: itemCrudLocal.motivoAnulacion,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }
    setIsDoingSomething(true);
    const response = await saveCajaAjuste(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //

  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {
            actionCrud === "new"
              ? itemGender === "M"
                ? "Nuevo"
                : "Nueva"
              : actionCrud === "update"
                ? "Editando"
                : actionCrud === "view"
                  ? "Ver"
                  : actionCrud === "delete"
                    ? "Anular"
                    : actionCrud === "enable"
                      ? "Habilitando"
                      : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="idTipoComprobante"
                options={tiposAjuste}
                getOptionLabel={(option) => option.descripcion + " (" + option.suma_resta + ")"}
                value={tiposAjuste.find(option => option.id === itemCrudLocal.idTipoAjuste) || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: 'idTipoAjuste',
                      value: newValue ? newValue.id : null,
                    }
                  });
                }}
                disabled={actionCrud === "view" || actionCrud === "delete"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de Ajuste"
                    size="small"
                  />
                )}
                ListboxProps={{ style: { maxHeight: "300px" } }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "delete"}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="importe"
                label="Importe"
                variant="outlined"
                size="small"
                name="importe"
                value={itemCrudLocal.importe}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "delete"}
              />
            </Grid>

            {actionCrud === "view" && itemCrud.motivoAnulacion !== "" && (
              <Grid item xs={12}>
                <TextField
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de Anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={itemCrudLocal.motivoAnulacion}
                  onChange={handleChange}
                  disabled={actionCrud === "view"}
                />
              </Grid>
            )}

            {actionCrud === "delete" && (
              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de Anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={itemCrudLocal.motivoAnulacion}
                  onChange={handleChange}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                {actionCrud !== "view" && (
                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleSave}
                    disabled={actionCrud === "view"}
                    startIcon={
                      actionCrud === "disable" ? (
                        <RemoveCircleOutlineIcon />
                      ) : actionCrud === "enable" ? (
                        <AddCircleOutlineIcon />
                      ) : (
                        <SaveIcon />
                      )
                    }
                  >
                    {actionCrud === "disable"
                      ? "Deshabilitar"
                      : actionCrud === "enable"
                        ? "Habilitar"
                        : "Guardar"}

                  </Button>
                )}
                <Button
                  variant="outlined"
                  onClick={handleCloseDialog}
                >
                  {actionCrud === "view" ? "Cerrar" : "Cancelar"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CajaAjusteDialog;